<!--
 * @Description:添加教学设计
 * @Author: Xyyyyyy
 * @Date: 2023-09-14 16:00:22
 * @LastEditors: PF
 * @LastEditTime: 2025-02-13 14:29:41
-->
<template>
  <div>
    <el-dialog class="w800 h800" :model-value="openKeJian" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加课件</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openKeJian', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="80px" class="demo-ruleForm" status-icon>
        <el-row>
          <el-col :span="12">
            <el-form-item label="学期:">
              <span>{{ruleForm.xqmc}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="课程:">
              {{ruleForm.kcmc}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="周次:">
              <span>第{{ruleForm.zc}}周</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="班级/节次:" class="bjjc">
              <el-row>
                <el-col :span="12">
                  <div style="width:300px">
                    <span>{{ruleForm.bjmc}}/星期{{ruleForm.xq}}第{{ruleForm.jc}}节</span>
                  </div>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学单元" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select class="mr10" v-model="ruleForm.jxdyid" @change="danDuanChange" style="width: calc(100% - 70px);">
                <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openAddJiaoXueDanYuan=true;row={kcid:ruleForm.kcid,kcmc:ruleForm.kcmc}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="教学内容" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select class="mr10" v-model="ruleForm.jxnrid" style="width: calc(100% - 70px);">
                <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id" />
              </el-select>
              <el-button type="primary" @click="openAddJiaoXueNeiRong=true;row={kcid:ruleForm.kcid,kcmc:ruleForm.kcmc,jxdyid:ruleForm.jxdyid}">添加</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="上传视频">
              <el-upload class="upload-demo" style="width:100%;" :show-file-list="false" drag :http-request="importspClick">
                <el-icon class="el-icon--upload">
                  <upload-filled />
                </el-icon>
                <div class="el-upload__text">
                  将文件拖到此处，或 <em>点击上传</em>
                </div>
              </el-upload>
              <div class="fujian" v-for="(item,index) in sps" :key="item.showPath">
                <el-link :href="baseurl+item.showPath" target="_blank" type="primary">{{item.oldname}}</el-link>
                <el-link @click="shipindel(index)"><span class="iconfont icon-shanchu"></span></el-link>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件" prop="fj">
              <el-upload style="width:100%" class="upload-demo" drag :show-file-list="false" accept=".pdf" :http-request="importClick">
                <el-icon class="el-icon--upload">
                  <upload-filled />
                </el-icon>
                <div class="el-upload__text">
                  将文件拖到此处，或 <em>点击上传</em>
                </div>
              </el-upload>
              <div class="fujian" v-for="(item,index) in fjs" :key="item.showPath">
                <el-link :href="baseurl+item.showPath" target="_blank" type="primary">{{item.oldname}}</el-link>
                <el-link @click="fuJianDel(index)"><span class="iconfont icon-shanchu"></span></el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span>
          <el-button type="primary" @click="submit()">保存 </el-button>
          <!-- <el-button type="primary" @click="submitFormTj()">保存并提交</el-button> -->
          <el-button @click="handleClose">关闭</el-button>
        </span>
      </template>
    </el-dialog>

  </div>
  <jiaoxuedanyuan v-if="openAddJiaoXueDanYuan" v-model:openAdd="openAddJiaoXueDanYuan" :row="row" @ReturnData="keChengChange" />
  <jiaoxueneirong v-if="openAddJiaoXueNeiRong" v-model:openAdd="openAddJiaoXueNeiRong" :row="row" @ReturnData="danDuanChange" />
</template>
<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import { UploadFilled } from '@element-plus/icons-vue'
import { uploadV2 } from '@/api/publicApi'
import jiaoxuedanyuan from '@/components/jiaoxuedanyuan.vue'
import jiaoxueneirong from '@/components/jiaoxueneirong.vue'
import {
  closeWindow,
  loadSelect,
  loadData,
  actionPost
} from '@/api/common.js'
const props = defineProps({
  openKeJian: {
    type: Boolean,
    required: true
  },
  kejianobj: {
    type: Object,
    required: false
  },
  row: {
    type: Object,
    required: false
  },
  chechboxtrue: {
    type: Array,
    required: false
  }
})
const ruleFormRef = ref(null)
const ruleForm = ref({
  xlbjkbjsids: []
})
const bjlist = ref()
// const jxsjmb = ref()// 模板内容
const baseurl = ref(process.env.VUE_APP_BASE_API)
const fjs = ref([]) // 附件
const sps = ref([]) // 视频
const jxnrData = ref([])
const jxdyData = ref([])
const kcid = ref() // 课程ID
const openAddJiaoXueDanYuan = ref() // 添加教学单元
const openAddJiaoXueNeiRong = ref() // 添加教学内容
const row = ref()
const emits = defineEmits(['update:openKeJian', 'ReturnData'])

// 选择课程
const keChengChange = (val) => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    data: jxdyData,
    parms: {
      kcid: val,
      order: 'sx',
      sort: 'asc'
    }
  })
}
// 选择教学单元
const danDuanChange = (val) => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list',
    data: jxnrData,
    parms: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' }
  })
}
// 删除视频
const shipindel = (ind) => {
  sps.value.splice(ind, 1)
}
// 删除附件
const fuJianDel = (ind) => {
  fjs.value.splice(ind, 1)
}
// 保存并提交
const submitFormTj = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
}
// 保存
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  const options = {
    url: '/api/v2/jiaowu/jiaowukejian',
    data: {
      dbgzid: row.value.id,
      xqid: ruleForm.value.xqid,
      zc: ruleForm.value.zc,
      jxdyid: ruleForm.value.jxdyid,
      jxnrid: ruleForm.value.jxnrid,
      fjids: [
        ...fjs.value.map((item) => {
          return item.id
        }),
        ...sps.value.map((element) => {
          return element.id
        })
      ],
      xlbjkbjsids: [ruleForm.value.id]
    }
  }
  //
  actionPost(options).then((res) => {
    if (res.code === 200) {
      emits('ReturnData')
      handleClose()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// const submit = async () => {
//   const form = unref(ruleFormRef)
//   if (!form) return
//   await form.validate()
//   ruleForm.value.zc = props.kejianobj.zc
//   ruleForm.value.xqid = props.kejianobj.xqid
//   ruleForm.value.dbgzid = props.kejianobj.chechboxtrue[0].id
//   ruleForm.value.fjids = [
//     ...fjs.value.map((item) => {
//       return item.id
//     }),
//     ...sps.value.map((element) => {
//       return element.id
//     })
//   ]
//   ruleForm.value.menuId = sessionStorage.getItem('menuId')
//   submitForm({
//     url: '/api/v2/jiaowu/jiaowukejian',
//     ruleFormRef: unref(ruleFormRef),
//     ruleForm: ruleForm.value,
//     callback: function (res) {
//       ruleForm.value = {
//         xlbjkbjsids: []
//       }
//       sps.value = []
//       fjs.value = []
//       closeWindow('openKeJian', emits, true)
//     }
//   })
// }
// 关闭
const handleClose = () => {
  emits('update:openKeJian', false)
}
// 上传视频
const importspClick = async (file) => {
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', 'jiaoxveshejikejian') // 文件地址类别 /common/cyrcglCpgl/202210/18/1.jpg
  uploadV2(formData)
    .then((res) => {
      const obj = {
        oldname: res.data.ymc,
        showPath: res.data.lj + res.data.mc,
        id: res.data.id
      }
      sps.value.push(obj)
      successPrompt('上传成功')
    })
    .catch()
}
// 上传文件
const importClick = async (file) => {
  const formData = new FormData()
  formData.append('file', file.file)
  formData.append('fwjjmc', 'public')
  formData.append('wjjmc', 'jiaoxveshejikejian') // 文件地址类别 /common/cyrcglCpgl/202210/18/1.jpg
  uploadV2(formData)
    .then((res) => {
      const obj = {
        oldname: res.data.ymc,
        showPath: res.data.lj + res.data.mc,
        id: res.data.id
      }
      fjs.value.push(obj)
      successPrompt('上传成功')
    })
    .catch()
}
// const dbgzid = ref()
// watch(
//   () => props.chechboxtrue,
//   () => {
//     if (props.chechboxtrue) {
//
//       bjlist.value = props.chechboxtrue
//     }
//   },
//   { deep: true, immediate: true }
// )
watch(
  () => props.openKeJian,
  () => {
    if (props.openKeJian) {
      row.value = props.row
      //
      keChengChange()
      loadData({
        url:
          '/api/v2/jiaowu/jiaowujiaoxuesheji/jiaoshijiaoxueshejikejian/' +
          props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          ruleForm.value.kcmc = res.data.kcmc
          ruleForm.value.zc = res.data.zc
          ruleForm.value.bjmc = res.data.bjmc
          ruleForm.value.xqmc = res.data.xqmc
          ruleForm.value = res.data
          keChengChange(res.data.kcid)
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
@import '@/assets/css/tanchuang.less';
@import '@/assets/css/tanchuangbuju.less';
:deep(.NumberColumns_5) {
  width: 800px;
}
.fujian {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.bjjc {
  width: 100%;
}
</style>
